import { motion, useReducedMotion } from "framer-motion";
import { GLASS, TYPE, GLOW } from "@/lib/glass";
import LightCard from "@/components/LightCard";

const BLOOM =
  "radial-gradient(circle, rgba(132,223,244,0.22) 0%, rgba(132,223,244,0.10) 34%, rgba(132,223,244,0.03) 56%, rgba(132,223,244,0) 72%)";

const line = (delay) => ({
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 1.4, delay, ease: GLASS.settle },
});

export default function WaitlistSuccess({ email, enteredAt }) {
  const still = useReducedMotion();

  return (
    <motion.div
      data-testid="waitlist-success"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.2, ease: GLASS.settle }}
      className="relative flex min-h-[220px] flex-col items-center justify-center"
    >
      <motion.div
        aria-hidden="true"
        data-testid="waitlist-success-bloom"
        initial={{ opacity: 0, scale: 0.55 }}
        animate={
          still
            ? { opacity: 0.6, scale: 1 }
            : { opacity: [0.45, 0.85, 0.45], scale: [0.92, 1.1, 0.92] }
        }
        transition={
          still
            ? { duration: 1.8, ease: GLASS.settle }
            : { duration: 5.2, ease: "easeInOut", repeat: Infinity }
        }
        className="pointer-events-none absolute left-0 right-0 top-0 mx-auto h-[min(340px,80vw)] w-[min(340px,80vw)] rounded-full"
        style={{ background: BLOOM, filter: "blur(22px)", marginTop: "calc(110px - min(170px, 40vw))" }}
      />

      <div
        data-testid="waitlist-success-message"
        role="status"
        aria-live="polite"
        style={{ fontSize: TYPE.lead, lineHeight: 1.85, letterSpacing: "0.02em", textShadow: GLOW.silverSoft }}
        className="relative text-center font-light text-[#F5F5F7]"
      >
        <motion.p {...line(0.25)} className="font-display" style={{ fontSize: "clamp(1.5rem, 3vw, 2.25rem)", letterSpacing: "0.03em", lineHeight: 1.2 }}>
          Thank you.
        </motion.p>

        <motion.span
          aria-hidden="true"
          data-testid="waitlist-success-hairline"
          initial={{ scaleX: 0, opacity: 0 }}
          animate={{ scaleX: 1, opacity: 1 }}
          transition={{ duration: 1.8, delay: 0.55, ease: GLASS.settle }}
          className="gold-hairline mx-auto my-5 origin-center"
        />

        <motion.p {...line(0.85)}>
          The light is on its way to{" "}
          <span data-testid="waitlist-success-email" className="text-[#84DFF4]" style={{ textShadow: GLOW.gold }}>
            {email}
          </span>
          .
        </motion.p>

        <motion.p {...line(1.3)} className="text-[#F5F5F7]/75" style={{ fontSize: TYPE.body }}>
          Watch for the foundational document in your inbox.
        </motion.p>
      </div>

      <LightCard seed={enteredAt} />
    </motion.div>
  );
}
